"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _main = _interopRequireDefault(require("../templates/main"));

var _shuffle = _interopRequireDefault(require("lodash/shuffle"));

var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

if (!nativeInputValueSetter) {
  nativeInputValueSetter = function nativeInputValueSetter(value) {
    this.value = value;
  };
}

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Main);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Main)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      animationItems: []
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeAnimation", function (target) {
      var animationItems = _this.state.animationItems.filter(function (item) {
        return item.key !== target;
      });

      _this.setState({
        animationItems: animationItems
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearDigit", function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var current = _this.props.value || '';
      var value;

      if (current.length) {
        // remove last digit
        value = current.substr(0, current.length - 1);
      }

      value = !value || !value.length ? null : value;
      _this.value = value;

      _this.runAnimation(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clear", function (event) {
      _this.value = null;

      _this.runAnimation(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputRef", function (el) {
      _this.input = el;

      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(el);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "runAnimation",
    value: function runAnimation(event) {
      var _this2 = this;

      // event.offsetX, event.layerX работают по разному в ФФ и хроме
      // потому что event.target разный
      var key = 'componentPinBlockAnimation' + new Date().getTime(),
          animationItems = [].concat(this.state.animationItems),
          transition = {
        key: key,
        // center + button center + ripple / 2
        top: event.currentTarget.offsetTop + event.currentTarget.offsetHeight / 2 - 13.5,
        left: event.currentTarget.offsetLeft + event.currentTarget.offsetWidth / 2 - 13.5,
        onAnimationEnd: function onAnimationEnd() {
          return _this2.removeAnimation(key);
        }
      };
      animationItems.push(transition);
      return this.setState({
        animationItems: animationItems
      });
    }
  }, {
    key: "select",
    value: function select(value) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var current = this.props.value === null || this.props.value === undefined ? '' : this.props.value;

      if (current.length < this.props.maxLength) {
        this.value = current + value;
      }

      this.runAnimation(event);
    }
  }, {
    key: "_stringify",
    value: function _stringify() {
      if (this.props.value === null || this.props.value === undefined) {
        return '';
      } else {
        return this.props.value;
      }
    }
  }, {
    key: "value",
    get: function get() {
      return this.props.value;
    },
    set: function set(value) {
      nativeInputValueSetter.call(this.input, value || '');
      this.input.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  label: '',
  collection: (0, _shuffle["default"])([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]),
  maxLength: 4,
  onChange: null,
  inline: false
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  /**
   * list storage
   */
  collection: _propTypes["default"].arrayOf(_propTypes["default"].number),
  label: _propTypes["default"].string,

  /**
   * max pin length
   */
  maxLength: _propTypes["default"].number,
  onChange: _propTypes["default"].func,

  /**
   * inline style
   */
  inline: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsXXLarge
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXXLarge
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default transparent
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.elLight
     */
    animationBackgroundColor: _propTypes["default"].string,

    /**
     * @default block
     */
    animationDisplay: _propTypes["default"].string,

    /**
     * @default palette.tInactive
     */
    focusColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    focusBackground: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    activeColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    activeBackground: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    labelColor: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default #e0e0e0
     */
    bulletIdleBackground: _propTypes["default"].string,

    /**
     * @default #e0e0e0
     */
    bulletIdleBorderColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    bulletFilledBackground: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    bulletFilledBorderColor: _propTypes["default"].string,

    /**
     * @default clearImg
     */
    clearIcon: _propTypes["default"].string,

    /**
     * @default deleteDigitImg
     */
    deleteIcon: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'PinBlock');
var _default = Main;
exports["default"] = _default;